// src/components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleDropdownToggle = (e) => {
    // Prevent default anchor action
    e.preventDefault();
    setDropdownOpen((prev) => !prev);
  };

  return (
    <header className="site-header">
      <div className="container">
        {/* Logo & Company Name */}
        <div className="logo-container">
          <img src="logo.jpg" alt="Company Logo" className="logo-img" />
          <span className="company-name">Left-Right Solutions</span>
        </div>

        {/* Navigation */}
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li className={`dropdown ${dropdownOpen ? 'active' : ''}`}>
              <a href="#services" onClick={handleDropdownToggle}>Services</a>
              <div className="dropdown-content">
                <div className="dropdown-section">
                  <h5>Courier Services</h5>
                  <a href="/courier/book">Book your shipment</a>
                  <a href="/courier/track">Track your shipment</a>
                </div>
                <div className="dropdown-section">
                <Link to="/visa"><h4>Visa Assistance</h4></Link>
                  <Link to="/visa/india-ev">India E-Visa</Link>
                  <Link to="/visa/india-regular">India Regular Sticker/Paper Visa</Link>
                  <Link to="/visa/us">US Visa</Link>
                  <Link to="/visa/uk">UK Visa</Link>
                  <Link to="/visa/schengen">Schengen Visa</Link>
                  <Link to="/visa/uae">UAE Visa</Link>
                  <Link to="/visa/japan">Japan Visa</Link>
                  <Link to="/visa/hongkong">Hongkong Visa</Link>
                  <Link to="/visa/cambodia">Cambodia Visa</Link>
                  <Link to="/visa/vietnam">Vietnam Visa</Link>
                </div>
                <div className="dropdown-section">
                  <Link to="/attestation"><h4>Attestation Services</h4></Link>
                  <Link to="/attestation/sla">Singapore Academy of Law (SLA)</Link>
                  <Link to="/attestation/notary">Notary</Link>
                  <Link to="/attestation/india">India Issued Certificates (MEA Apostile, HRD)</Link>
                  <Link to="/attestation/uae">UAE Attestation</Link>
                  <Link to="/attestation/hci">HCI Attestation</Link>
                </div>
                <div className="dropdown-section">
                  <Link to="/it"><h4>IT Services</h4></Link>
                  <Link to="/it/website-creation">Website Creation</Link>
                  <Link to="/it/digital-marketing">Digital Marketing</Link>
                  <Link to="/it/support">On Site and Remote Support</Link>
                  <Link to="/it/cctv-installation">CCTV Installation</Link>
                  <Link to="/it/attendance">Attendance System Installation</Link>
                </div>
                <div className="dropdown-section">
                  <h5>Other Services</h5>
                  <Link to="/pickup-drop/enquiry">Pickup and Drop Services</Link>
                  <Link to="/handyman/enquiry">Handyman</Link>
                </div>
              </div>
            </li>
            {/* <li><Link to="/contact">Contact Us</Link></li> */}
          </ul>
        </nav>

        {/* Sign Up Button */}
        <Link to="/contact"><a href="#signup" className="signup-button">Contact Us</a></Link>
      </div>
    </header>
  );
}

export default Header;
